var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, Defaults, CustomElement, ViewChild, Watch, PropertyConverters } from '@pacem/pacem-core';
import { PacemDialogBase, DialogButtons } from './dialog-abstractions';
//namespace Pacem.Components.UI {
let PacemDialogElement = class PacemDialogElement extends PacemDialogBase {
    constructor() {
        super(...arguments);
        this.buttons = DialogButtons.Ok;
        this.okCaption = 'OK';
        this.yesCaption = 'Yes';
        this.noCaption = 'No';
        this.cancelCaption = 'Cancel';
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'buttons':
                //
                break;
        }
    }
    open(state) {
        const retval = super.open(state);
        switch (this.buttons) {
            case DialogButtons.Ok:
            case DialogButtons.OkCancel:
                this.dialogButtons.ok.focus();
                break;
            default:
                this.dialogButtons.yes.focus();
                break;
        }
        return retval;
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        // HACK: move the buttons outside the .pacem-scrollable element in the lightbox
        //requestAnimationFrame(() => {
        //    const elFrom = this.lightbox && this.lightbox.container;
        //    if (!Utils.isNull(elFrom)) {
        //        elFrom.appendChild(this._buttons);
        //        this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'dialogButtons', currentValue: this.dialogButtons }));
        //    } else {
        //        this.log(Logging.LogLevel.Warn, `Could not find the lightbox container as expected.`);
        //    }
        //});
    }
    /** Gets the 'ok', 'yes', 'no' and 'cancel' dialog buttons. */
    get dialogButtons() {
        const btns = this._buttons;
        return {
            ok: btns && btns.firstElementChild.firstElementChild,
            yes: btns && btns.firstElementChild.children.item(1),
            no: btns && btns.firstElementChild.children.item(2),
            cancel: btns && btns.firstElementChild.lastElementChild
        };
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemDialogElement.prototype, "buttons", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemDialogElement.prototype, "okCaption", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemDialogElement.prototype, "yesCaption", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemDialogElement.prototype, "noCaption", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemDialogElement.prototype, "cancelCaption", void 0);
__decorate([
    ViewChild(`.${PCSS}-dialog-buttons`)
], PacemDialogElement.prototype, "_buttons", void 0);
__decorate([
    ViewChild(P + '-lightbox')
], PacemDialogElement.prototype, "lightbox", void 0);
PacemDialogElement = __decorate([
    CustomElement({
        tagName: P + '-dialog', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-lightbox modal="true" logger="{{ :host.logger }}">
    <${P}-content></${P}-content>
    <div class="${PCSS}-dialog-buttons ${PCSS}-buttonset buttons" part="dialog-buttons" slot="bottom">
        <div class="buttonset-left">
            <${P}-button class="button button-size size-small primary dialog-ok" css-class="{{ {'buttonset-last': :host.buttons === 'ok'} }}" on-click=":host.commit('ok', $event)" disabled="{{ :host.disabled || this.hide }}" hide="{{ :host.buttons !== 'ok' && :host.buttons !== 'okcancel' }}"><${P}-text text="{{ :host.okCaption }}"></${P}-text></${P}-button>
            <${P}-button class="button button-size size-small primary dialog-yes" css-class="{{ {'buttonset-first': :host.buttons !== 'ok' || :host.buttons !== 'okcancel'} }}" on-click=":host.commit('yes', $event)" disabled="{{ :host.disabled || this.hide }}" hide="{{ :host.buttons === 'ok' || :host.buttons === 'okcancel' }}"><${P}-text text="{{ :host.yesCaption }}"></${P}-text></${P}-button>
            <${P}-button class="button button-size size-small dialog-no" css-class="{{ {'buttonset-last': :host.buttons === 'yesno'} }}" on-click=":host.commit('no', $event)" disabled="{{ :host.disabled || this.hide }}" hide="{{ :host.buttons !== 'yesno' && :host.buttons !== 'yesnocancel' }}"><${P}-text text="{{ :host.noCaption }}"></${P}-text></${P}-button>
            <${P}-button class="button button-size size-small dialog-cancel" on-click=":host.commit('cancel', $event)" disabled="{{ :host.disabled || this.hide }}" hide="{{ :host.buttons !== 'yesnocancel' && :host.buttons !== 'okcancel' }}"><${P}-text text="{{ :host.cancelCaption }}"></${P}-text></${P}-button>
        </div>
    </div>
</${P}-lightbox>`
    })
], PacemDialogElement);
export { PacemDialogElement };
//}
